import { getMutationHandler } from '@frontend/duck-tape';
import { showToast } from '@frontend/web-react';

export const handleMutation = getMutationHandler({ showToast });
